import MonthlyInstallment from './MonthlyInstallment';
import MonthlyInstallmentUI from './MonthlyInstallmentUI';

const Installment = {
    Container: MonthlyInstallment,
    MonthlyInstallmentUI
};

export default Installment;
